import {observer} from 'mobx-react';
import React from 'react';
import {X5LessonStore} from '../X5LessonStore';

@observer
export class EditPageForm extends React.Component<{ store: X5LessonStore }> {
  render() {
    const {store} = this.props;

    if (store.editPage === null)
      return null;

    const name = store.editPage.name;
    return (
      <div className="row">
        <div className="col">
          <div className={name.formGroupClassName}>
            <input className="form-control" type="text"
                   value={name.value}
                   onChange={name.onChangeHandler}
                   onKeyDown={store.completeOnEnter}
                   onBlur={name.markTouched}/>
            <div className="invalid-text">Enter name</div>
          </div>
        </div>
      </div>);
  }
}
